import Tables from 'src/class/Tables';
import i18n from 'src/i18n';

export const configConsolidatedHarvestTable = (data) => {
  const harvestTable = { ...Tables.Table };

  harvestTable.tableColumns = [
    {
      prop: 'farm',
      label: i18n.t('common_words.farm'),
      minWidth: 100,
      align: 'left',
    },
  ];

  if (data && data.harvest) {
    harvestTable.tableColumns.push(
      ...data.harvest.map((value) => ({
        prop: `harvest.${value}`,
        label: value,
        minWidth: 100,
        align: 'center',
      }))
    );
  }

  harvestTable.tableColumns.push({
    prop: 'total',
    label: i18n.t('production.total'),
    minWidth: 100,
    align: 'center',
  });

  const harvestSearch = { ...Tables.Search };

  return { harvestTable, harvestSearch };
};

export const configConsolidatedRejectedTable = (data) => {
  const rejectedTable = { ...Tables.Table };

  rejectedTable.tableColumns = [
    {
      prop: 'farm',
      label: i18n.t('common_words.farm'),
      minWidth: 100,
      align: 'left',
    },
  ];

  if (data && data.rejected) {
    rejectedTable.tableColumns.push(
      ...data.rejected.map((value) => ({
        prop: `rejected.${value}`,
        label: value,
        minWidth: 100,
        align: 'center',
      }))
    );
  }

  rejectedTable.tableColumns.push({
    prop: 'total',
    label: i18n.t('production.total'),
    minWidth: 100,
    align: 'center',
  });

  const rejectedSearch = { ...Tables.Search };

  return { rejectedTable, rejectedSearch };
};
